import APIController from "./APIController"
import SyncHelper from '../Helper/SyncHelper';

const Order = () => {
    //Requesthelper
    const { jsonRequest } = APIController()
    const { calculateOrderPrice } = SyncHelper()

    const createOrder = async (orderDTO, workspaceId) => {
        const data = await jsonRequest(`/${workspaceId}/order/new-preorder`, "POST", orderDTO);
        return data;
    };

    const caluclatePrice = async (orderDTO) => {
        return calculateOrderPrice(orderDTO);
    };

    return {
        createOrder,
        caluclatePrice,
    }
}

export default Order